module.exports = __webpack_public_path__ + "static/media/res2.4722bb71.PNG";